import { type PropsWithChildren } from 'react';
import { ModalProvider } from '@banhala/ui-kit';
import type { ILogging } from '../api/types/ILogging';
import { AnalyticsProvider } from './AnalyticsContext';
import { AndroidBackPressLogger } from './AndroidBackPressLogger';

type Props = PropsWithChildren<{
  screen: string;
  getDefaults?: () => ILogging | undefined;
}>;

/**
 * 페이지 레벨 스코프 묶음.
 * - `AnalyticsProvider`: 이 범위 내에서 발화되는 이벤트의 기본 SCREEN / defaults 설정
 * - `ModalProvider`: 이 범위에서 열리는 BottomSheet/Modal이 같은 analytics 컨텍스트 안에 렌더되도록 보장
 *
 * 기존 `AnalyticsProvider` 단독 사용 시 ModalProvider는 앱 상위(혹은 Navigation screenLayout)에
 * 있어서, 거기 등록된 Modal이 AnalyticsProvider 트리 바깥에 렌더됨 → `useAnalyticsContext()`가
 * 기본값(`{}`)을 반환해 로깅 필드 누락이 발생했음. AnalyticsScreen은 내부에 ModalProvider를
 * 한 겹 더 둬서 이 문제를 구조적으로 해결함.
 */
export const AnalyticsScreen = ({ screen, getDefaults, children }: Props) => (
  <AnalyticsProvider screen={screen} getDefaults={getDefaults}>
    <ModalProvider>
      <AndroidBackPressLogger />
      {children}
    </ModalProvider>
  </AnalyticsProvider>
);
